export default __webpack_public_path__ + "static/media/preloader3.fa074571.gif";